import axios from '@/utilities/axios-global'

const POST_BLOB = (context, payload) => {
  let bodyFormData = new FormData()
  bodyFormData.append('file', payload.blob)

  let url = context.rootState.user.baseApiUrl + '/blobstore?blobPathPrefix=' + encodeURIComponent(payload.blobPathPrefix) + '&fileExtension=' + payload.fileExtension

  if (payload.containerName) {
    url += '&containerName=' + payload.containerName
  }

  return axios.post(url, bodyFormData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(
    response => {
      return response
    },
    error => {
      return error
    }
  )
}

export default {
  POST_BLOB
}
